export function buildMyobMappingLabels(profiles, businessesAndAccounts) {
    const profileNames = new Map();
    const businessNames = new Map();
    const contactNames = new Map();

    profiles.forEach(profile => profileNames.set(profile.uid, profile.username));
    Object.entries(businessesAndAccounts || {}).forEach(([profileId, businesses]) => {
        (businesses || []).forEach(business => {
            businessNames.set(`${profileId}|${business.uid}`, business.name);
            (business.contacts || []).forEach(contact => {
                contactNames.set(`${profileId}|${business.uid}|${contact.uid}`, contact.name);
            });
        });
    });

    return {profileNames, businessNames, contactNames};
}

export function mappingDisplay(mapping, labels) {
    if (!mapping?.myob_contact_id) return 'Not configured';
    const contactKey = [
        mapping.myob_profile_id,
        mapping.myob_business_id,
        mapping.myob_contact_id,
    ].join('|');
    return labels.contactNames.get(contactKey) || mapping.myob_contact_id;
}
